import React from "react";
import { Link } from "react-router-dom";
import { activeBanner } from "../data/content";
import { useSiteSettings } from "../hooks/useContent";
import { linkKind } from "./MarkdownText";
import "./SiteBanner.css";

/**
 * Site-wide announcement from settings `banner` (contract §3.13.1): one line
 * of text and an optional link. Nothing renders while it is hidden or once
 * its `ends_on` date has passed in Nassau. The link is a root-relative path
 * (router link) or an https URL (new tab); any other target is dropped.
 *
 * @param {object} props
 * @param {Date} [props.now] - Injected clock for tests
 */
export default function SiteBanner({ now = new Date() }) {
  const banner = activeBanner(useSiteSettings().banner, now);
  if (!banner) return null;

  const kind = banner.link_url ? linkKind(banner.link_url) : null;
  const label = banner.link_label || banner.link_url;
  let link = null;
  if (kind === "internal") {
    link = <Link to={banner.link_url}>{label}</Link>;
  } else if (kind === "external") {
    link = (
      <a href={banner.link_url} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    );
  }

  return (
    <aside className="site-banner" aria-label="Announcement">
      <p className="container">
        {banner.text}
        {link ? <> {link}</> : null}
      </p>
    </aside>
  );
}
